<template>
    <div class="modal bg-opacity-50 bg-black" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        Send Rewards via Mail
                    </h5>
                    <span aria-hidden="true" role="button" @click="close"><i class="fas fa-xmark"></i></span>
                </div>
                <div class="modal-body">
                    <label>Notification</label>
                    <input type="text" class="form-control" name="inpsel_equipment_id" autocomplete="off"
                        placeholder="Equipment Name" @input="this.updateNotificationId()"
                        @change="this.updateNotificationId()" v-model="this.selectedNotification"
                        list="notification-list" id="inpsel_equipid">
                    <datalist id="notification-list">
                        <option :value="notification.name" :data-id="notification.id"
                            v-for="notification in store.custom.notificationList" :key="notification">{{
                                notification.name }}</option>
                    </datalist>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" @click="sendRewards">
                        Send
                    </button>
                    <button type="button" class="btn btn-secondary" @click="close">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import store from "node-back-client/src/store";
    import ToastService from "toast/src/services/toast";
    import ModalService from "modal/src/services/Modal";

    export default {
        name: "SendRewards",
        data() {
            return {
                store: store,
                selectedNotification: null,
                selectedNotifId: null,
            };
        },
        props: {
            data: {
                entity: Object,
                show: Boolean,
            },
            api: Object,
        },
        components: {
        },
        methods: {
            close() {
                let data = this.data;
                data.show = false;
            },
            sendRewards() {
                const id = this.data.entity._id
                if (!this.selectedNotification) {
                    ToastService.Notify({
                        title: "Failed",
                        message: "Please select Notification",
                    });
                    return
                }
                ModalService.Show(
                    {
                        title: `Send Reward  via Mail`,
                        message: `Do you want to send ${this.selectedNotification}?`,
                    },
                    async () => {
                        const res = await this.api.charlist.sendRewardsviaMail(id, this.selectedNotifId);
                        if (res.message === "Failed") {
                            ToastService.Notify({
                                title: "Error",
                                message: "Unable to save.",
                            });
                        } else {
                            ToastService.Notify({
                                title: "Success",
                                message: `'${this.selectedNotification}' successfully sent!`,
                            });

                        }
                        this.close()
                    }
                );
            },
            updateNotificationId() {
                const selectedOption = document.querySelector(
                    `#notification-list option[value='${this.selectedNotification}']`
                );
                if (selectedOption) {
                    this.selectedNotifId = parseInt(
                        selectedOption.getAttribute("data-id")
                    );
                }
            },
            formatKey(key) {
                return key.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
                    return str.toUpperCase()
                })
            },
        },
        mounted() {

        }
    };
</script>

<style></style>